import React from "react";
import { Download } from "lucide-react";
import { CalendarEvent } from "./types";

interface ExportButtonProps {
  events: CalendarEvent[];
  filename?: string;
}

const ExportButton: React.FC<ExportButtonProps> = ({
  events,
  filename = "calendar-events.csv",
}) => {
  const handleExport = () => {
    // Build CSV content
    const headers = [
      "Title",
      "Asset Type",
      "Status",
      "Start Date",
      "End Date",
      "Berth Number",
      "User Name",
      "User Email",
    ];

    const rows = events.map((event) => [
      event.title,
      event.assetType || "berth",
      event.status,
      event.start,
      event.end || "Ongoing",
      event.berthNumber,
      event.user?.name || "",
      event.user?.email || "",
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((row) =>
        row
          .map(
            (cell) =>
              // Escape commas, quotes, etc. in cell values
              `"${String(cell).replace(/"/g, '""')}"`,
          )
          .join(","),
      ),
    ].join("\n");

    // Create download link
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button
      onClick={handleExport}
      className="flex items-center justify-center gap-2 px-4 py-2 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 text-gray-700"
      aria-label="Export to CSV"
    >
      <Download className="w-4 h-4" />
      <span className="text-sm font-medium">Export to CSV</span>
    </button>
  );
};

export default ExportButton;
